var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:_vm.stepName,staticStyle:{"position":"relative"}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-header"},[_c('p',[_vm._v("Veuillez patienter...")])])
}]

export { render, staticRenderFns }